import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { Session } from '../../types';
import getSession from '../../api/handlers/session/getSession';

export function useSession(): UseQueryResult<Session> {
  return useQuery({
    queryKey: ['session'],
    queryFn: getSession,
  });
}
